(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var lmRelatedSection = function() { return document.querySelector(".related-products"); };

var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = lmRelatedSection();
  if (productRecommendationsSection === null) { return; }
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};

// Lala & Mer: show every fabric from the same line as a carousel; fall back to
// Shopify recommendations when the product has no line or the line has no other fabrics.
var lmLoadLineCarousel = function() {
  var section = lmRelatedSection();
  if (section === null) { return; }
  if (!section.dataset.lineUrl) { loadProductRecommendationsIntoSection(); return; }
  fetch(section.dataset.lineUrl)
    .then(function(r) { if (!r.ok) { throw new Error('line fetch failed'); } return r.text(); })
    .then(function(html) {
      var container = document.createElement("div");
      container.innerHTML = html;
      var payload = container.querySelector(".lm-line-carousel-payload");
      if (!payload) { throw new Error('no payload'); }
      // remove the fabric the customer is already looking at
      var handle = section.dataset.currentHandle;
      payload.querySelectorAll(".product-block").forEach(function(block) {
        var link = block.querySelector('a[href*="/products/"]');
        if (!link) { return; }
        var path = link.getAttribute("href").split("?")[0];
        if (path === "/products/" + handle || path.slice(-("/products/" + handle).length) === "/products/" + handle) {
          block.remove();
        }
      });
      if (payload.querySelectorAll(".product-block").length === 0) { throw new Error('line empty'); }
      section.innerHTML = "";
      while (container.firstChild) { section.appendChild(container.firstChild); }
      // show arrows only when there is something to scroll to
      var car = section.querySelector(".lm-line-carousel");
      var track = section.querySelector(".lm-car-track");
      if (car && track && track.scrollWidth > track.clientWidth + 10) {
        car.classList.add("lm-car-scrollable");
      }
    })
    .catch(function() { loadProductRecommendationsIntoSection(); });
};

document.addEventListener("click", function(e) {
  var btn = e.target.closest ? e.target.closest(".lm-car-arrow") : null;
  if (!btn) { return; }
  var track = btn.closest(".lm-line-carousel").querySelector(".lm-car-track");
  if (!track) { return; }
  var amount = track.clientWidth * 0.8;
  track.scrollBy({ left: btn.classList.contains("lm-car-prev") ? -amount : amount, behavior: "smooth" });
});

document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    lmLoadLineCarousel();
  }
});

lmLoadLineCarousel();

  } catch(e) { console.error(e); }
})();
})();
